import { schema } from 'normalizr';

import { compact, date } from '../../../../../helpers/compact';
import { LinkType } from '../../../../../types';
import {
  Document,
  DocumentType,
  DocumentLink,
} from '../../../../../types/document';
import { toDocType } from '../../../mapping';

const getDocumentLink = (doc: any): DocumentLink =>
  compact({
    ...doc,
    linkType: LinkType.LINK_TYPE_DOC,
    type: toDocType(doc?.type),
  });

const processDocument: schema.StrategyFunction<Document> = (doc) =>
  compact({
    id: doc.id,
    uid: doc.uid,
    type: toDocType(doc.type),
    lang: doc.lang,
    alternateLanguages: doc.alternate_languages?.map(getDocumentLink),
    createdAt: date(
      doc.data?.publication_date || doc.first_publication_date,
      'YYYY-MM-DDTHH:mm:ssZ'
    ),
    updatedAt: date(doc.last_publication_date, 'YYYY-MM-DDTHH:mm:ssZ'),
    disableRgpbBanner:
      doc.uid === 'terms-of-use' ||
      doc.uid === 'conditions-generales-d-utilisation',
  });

/**
 * Function to transform a prismic custom types to a document.
 */
export const documentEntity = <T extends Document = Document>(
  type: DocumentType,
  { processStrategy, ...rest }: schema.EntityOptions<T>
): schema.Entity<T> =>
  new schema.Entity<T>(
    type,
    {},
    {
      idAttribute: 'id',
      processStrategy: (entity, parent, key) => {
        if (!entity) {
          return undefined;
        }

        if (entity?.tags?.indexOf('Obsolète') >= 0) {
          return undefined;
        }

        return processStrategy !== undefined
          ? {
              ...processDocument(entity, parent, key),
              ...processStrategy(entity, parent, key),
            }
          : (processDocument(entity, parent, key) as T);
      },
      ...rest,
    }
  );
